module.exports = __webpack_public_path__ + "static/media/financing.2f9706e9.svg";